import { ResourceSettingsMenu } from "./controls/resource_settings_menu";
import { ResourceTitle } from "./controls/resource_title";
import { ExternalResourceWarning } from "./external_resource_warning";
import { TldrawWhiteboard } from "./tldraw_whiteboard";

import { ResourceType } from "shared/types";

function WhiteboardResource({ resource }: { resource: ResourceType }) {
  return (
    <div className="flex flex-column w-full h-full">
      <div className="flex items-center p1 bg-black body-s text-black-tint-70 resource-controls">
        <ResourceTitle resource={resource} />
        <ResourceSettingsMenu editVerb="Draw" />
      </div>

      <ExternalResourceWarning />

      <div className="flex-auto">
        <TldrawWhiteboard resource={resource} />
      </div>
    </div>
  );
}

export { WhiteboardResource };
